function saveLoginToSessionStorage(userData) {
  const dataToSave = JSON.stringify(userData);
  sessionStorage.setItem('loanForceInsiderPortal', dataToSave);
}

export default saveLoginToSessionStorage;
